import { render, staticRenderFns } from "./simOpenTnVip.vue?vue&type=template&id=9f9a70dc&scoped=true&"
import script from "./simOpenTnVip.vue?vue&type=script&lang=js&"
export * from "./simOpenTnVip.vue?vue&type=script&lang=js&"
import style0 from "./simOpenTnVip.vue?vue&type=style&index=0&id=9f9a70dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9a70dc",
  null
  
)

export default component.exports